import { monthlySalaryMode, yearlySalaryMode } from "@/constants/common";

import { ApiEntity } from "@/components/profile/workExperience/types";

import { formatCurrency } from "./helper";

export const getSalaryBasedOnSiteContext = ({
  currency,
  absoluteSalary,
  siteContext,
  salaryMode,
}: {
  currency: string;
  absoluteSalary: number | string;
  siteContext: string;
  salaryMode: ApiEntity;
}) => {
  if (absoluteSalary === "") {
    return "-";
  }
  let tempSalary = absoluteSalary;
  let isAnnualSalary = true;
  if (siteContext === "rexmonster") {
    if (salaryMode && salaryMode.id != yearlySalaryMode) {
      tempSalary = Number(absoluteSalary) * 12;
    }
    isAnnualSalary = true;
  } else {
    if (salaryMode && salaryMode.id != monthlySalaryMode) {
      tempSalary = Number((Number(absoluteSalary) / 12).toFixed(2));
    }
    isAnnualSalary = false;
  }

  const salary = formatCurrency(Number(tempSalary), currency);
  return `${currency ?? "INR"} ${salary} ${isAnnualSalary ? " (Annually)" : " (Monthly)"}`;
};
